/* Rough Old Glass – trade login & trade pricing (Oct 2026)
   - A visible "Trade login" button in the header (desktop and mobile).
   - Every sign-in link brings the customer back to the page they were on
     (the calculators in particular) instead of their order history.
   - Trade customers see retail price, their trade price and their margin
     side by side on both calculators.
   - Signed-in customers find their details already filled in on both calculators.
   - Panels calculator items are written in the office / Capsule layout in the basket and order.
   - Staff mode for accounts tagged Staff: price for a customer, then make a draft order.
   - The PO / project name from either calculator follows the customer to the basket.
   Relies on window.ROG_ACCOUNT, printed by snippets/trade-orders-code.liquid. */
(function () {
  var A = window.ROG_ACCOUNT || { loggedIn: false, isTrade: false, loginUrl: '/customer_authentication/login', accountUrl: '/account' };

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function money(n) { return '£' + (Math.round(n * 100) / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function num(s) { var n = parseFloat(String(s).replace(/[^0-9.\-]/g, '')); return isFinite(n) ? n : 0; }

  var css = [
    '.rog-cta-trade a{text-decoration:none}',
    '.rog-cta-trade a p:first-child{font-weight:700}',
    '.rog-mobile-trade{display:none;padding:8px 16px;background:#3d4c4f;text-align:center;font-size:14px}',
    '.rog-mobile-trade a{color:#fff;text-decoration:none;font-weight:600}',
    '.rog-mobile-trade a span{opacity:.8;font-weight:400}',
    '@media (max-width:767px){.rog-mobile-trade{display:block}}',
    '.rog-trade-prompt{display:flex;flex-wrap:wrap;align-items:center;gap:10px 14px;margin:14px 0;padding:12px 14px;border:2px solid #3d4c4f;border-radius:6px;background:#fff;color:#1f2a2b;font-size:15px;line-height:1.4}',
    '.rog-trade-prompt strong{display:block}',
    '.rog-trade-prompt .rog-btn-login{display:inline-block;padding:10px 18px;border-radius:22px;background:#3d4c4f;color:#fff !important;text-decoration:none !important;font-weight:700;letter-spacing:.02em;white-space:nowrap}',
    '.rog-trade-on{margin:14px 0;padding:10px 14px;border-left:4px solid #2f6b4a;background:#e9f3ec;color:#1d3b2a;font-size:15px;border-radius:4px}',
    '.rog-margin{margin:16px 0;padding:14px 16px;border:1px solid #d8d8d0;border-radius:6px;background:#fafaf7;color:#1f2a2b;text-align:left;font-size:15px}',
    '.rog-margin h3{margin:0 0 8px;font-size:15px;letter-spacing:.04em;text-transform:uppercase;color:#3d4c4f}',
    '.rog-margin table{width:100%;border-collapse:collapse;font-variant-numeric:tabular-nums}',
    '.rog-margin td{padding:5px 0;border-bottom:1px solid #e6e6df}',
    '.rog-margin td:last-child{text-align:right;font-weight:600}',
    '.rog-margin tr.rog-strong td{font-weight:700;color:#2f6b4a}',
    '.rog-margin p{margin:8px 0 0;font-size:13px;color:#6b6f74}',
    '.rog-margin td small{display:block;font-weight:400;font-size:13px;color:#6b6f74}'
  ].join('');
  var st = el('style'); st.textContent = css; document.head.appendChild(st);

  /* 1. Every sign-in link returns to this page */
  function fixLoginLinks(root) {
    (root || document).querySelectorAll('a[href]').forEach(function (a) {
      var h = a.getAttribute('href') || '';
      if (/\/account\/login|customer_authentication\/redirect|customer_authentication\/login(?!\?return_to)/.test(h)) a.setAttribute('href', A.loginUrl);
    });
  }

  /* 2. Visible header button + mobile bar */
  function headerButton() {
    var label, sub, href;
    if (A.isTrade) { label = 'Trade account'; sub = 'Trade prices on'; href = A.accountUrl; }
    else if (A.loggedIn) { label = 'My account'; sub = 'Orders & details'; href = A.accountUrl; }
    else { label = 'Trade login'; sub = 'See trade prices'; href = A.loginUrl; }

    var menu = document.querySelector('.logo-area .side-menu');
    if (menu && !menu.querySelector('.rog-cta-trade')) {
      var cta = el('div', 'cta rog-cta-trade');
      var a = el('a'); a.href = href;
      var p1 = el('p'); p1.textContent = label; var p2 = el('p'); p2.textContent = sub;
      a.appendChild(p1); a.appendChild(p2); cta.appendChild(a); menu.appendChild(cta);
    }
    var mh = document.getElementById('mobile-header');
    if (mh && !document.querySelector('.rog-mobile-trade')) {
      var bar = el('div', 'rog-mobile-trade');
      var ma = el('a'); ma.href = href;
      ma.innerHTML = A.isTrade ? 'Trade account <span>· trade prices on</span>'
        : (A.loggedIn ? 'My account' : 'Trade customer? <span>Log in for trade prices</span>');
      bar.appendChild(ma); mh.parentNode.insertBefore(bar, mh.nextSibling);
    }
  }

  /* 3. Calculator pages: a clear prompt before starting, or confirmation that trade pricing is on */
  function onCalculator() { return /\/pages\/(bespoke-tiles|your-details|customise)/.test(location.pathname); }
  function calculatorPrompt() {
    if (A.isStaff || !onCalculator() || document.querySelector('.rog-trade-prompt, .rog-trade-on')) return;
    var anchor = document.querySelector('.frames-bespoke .framebox h1') ||          /* framed: your details */
                 document.querySelector('.your--details h1, .your--details h2') ||  /* panels: your details */
                 null;
    if (!anchor) return;
    var box;
    if (A.isTrade) {
      box = el('div', 'rog-trade-on');
      box.textContent = 'You’re signed in to your trade account. Your estimate will show the retail price, your trade price and your margin.';
    } else if (!A.loggedIn) {
      box = el('div', 'rog-trade-prompt');
      var txt = el('div'); txt.innerHTML = '<strong>Trade customer?</strong>Log in first to see your trade price alongside the retail price.';
      var b = el('a', 'rog-btn-login'); b.href = A.loginUrl; b.textContent = 'Trade login';
      box.appendChild(txt); box.appendChild(b);
    } else { return; }
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
  }

  /* 4a. Panels calculator: retail vs trade vs margin */
  function panelsStore() {
    var w = document.querySelector('.customiser--wrapper');
    var vm = w && w.__vue__;
    return vm && vm.$root && vm.$root.$store ? vm.$root.$store.state : null;
  }
  function tierCost(tiers, total) {
    var t = (tiers || []).find(function (x) { return total >= Number(x.min) && total < Number(x.max); });
    if (!t) t = (tiers || [])[tiers.length - 1];
    if (!t) return 0;
    return t.surchargeType === 'monetary' ? Number(t.surcharge) : total * Number(t.surcharge) / 100;
  }
  function panelsMargin() {
    var s = panelsStore();
    var totalBox = document.querySelector('.tiles-customiser .total');
    if (!s || !totalBox || String(s.isTradeCustomer) !== 'true') return;
    var tradeGoods = Number(s.totalTilesPrice) || 0;
    var discount = Number(s.totalTradeDiscount) || 0;
    var trade = Number(s.totalPriceWithDelivery) || 0;
    if (!trade) return;
    var retailGoods = tradeGoods + discount;
    var fit = s.fit && s.fit.hasFitting ? tierCost(s.fit.tiers, retailGoods) : (s.fit && s.fit.totalPrice ? s.fit.totalPrice * (retailGoods / Math.max(tradeGoods, 1)) : 0);
    var retailWithFit = retailGoods + fit;
    var retail = retailWithFit + tierCost(s.delivery && s.delivery.tiers, retailWithFit);
    window.ROG_TRADE_PCT = Number(s.tradeDiscount) || 0;
    renderMargin(totalBox, retail, trade, 'Prices include UK mainland delivery');
  }

  /* 4b. Framed mirror calculator: relabel the review totals and add margin */
  function framedMargin() {
    var pt = document.querySelector('.product-total');
    if (!pt) return;
    var sub = pt.querySelector('.subtotal'), dis = pt.querySelector('.discount'), tot = pt.querySelector('.total');
    if (!sub || !tot) return;
    var retail = num(sub.textContent.split(':').pop()), trade = num(tot.textContent.split(':').pop());
    if (!retail || !(retail > trade)) return;   /* not a trade customer */
    if (!sub.dataset.rog) {
      sub.innerHTML = '<span>Retail price:</span> ' + money(retail);
      if (dis) dis.innerHTML = '<span>Your trade discount:</span> -' + money(retail - trade);
      tot.innerHTML = '<span>Your trade price:</span> ' + money(trade);
      sub.dataset.rog = '1';
    }
    renderMargin(pt, retail, trade, 'Per mirror');
  }

  function renderMargin(anchor, retail, trade, note) {
    var box = anchor.parentNode.querySelector('.rog-margin');
    if (!box) { box = el('div', 'rog-margin'); anchor.parentNode.insertBefore(box, anchor.nextSibling); }
    var margin = retail - trade;
    var pct = Math.round(Number(window.ROG_TRADE_PCT) || (retail ? margin / retail * 100 : 0));
    var html = '<h3>Trade pricing</h3><table>' +
      '<tr><td>Retail price</td><td>' + money(retail) + ' inc VAT<small>' + money(retail / 1.2) + ' ex VAT</small></td></tr>' +
      '<tr class="rog-strong"><td>Trade discount (' + pct + '%)</td><td>−' + money(margin) + ' inc VAT<small>−' + money(margin / 1.2) + ' ex VAT</small></td></tr>' +
      '<tr><td>Your trade price</td><td>' + money(trade) + ' inc VAT<small>' + money(trade / 1.2) + ' ex VAT</small></td></tr>' +
      '</table><p>' + note + '. Retail is the price a customer would see on this website for the same specification.</p>';
    if (box.dataset.html !== html) { box.innerHTML = html; box.dataset.html = html; }
  }


  /* 5. PO / project reference: whatever the customer types in either calculator
        is copied to the basket's "PO Number" box (a cart attribute, which Sufio
        prints on the invoice). Kept for 3 days as a fallback. */
  var PO_KEY = 'rogPO', PO_TTL = 3 * 864e5, poLast = null;
  function poGet() {
    try { var o = JSON.parse(localStorage.getItem(PO_KEY) || 'null'); return o && Date.now() - o.t < PO_TTL ? o.v : ''; } catch (e) { return ''; }
  }
  function poSave(v) {
    v = String(v == null ? '' : v).trim().slice(0, 100);
    if (v === poLast) return; poLast = v;
    try { if (v) localStorage.setItem(PO_KEY, JSON.stringify({ v: v, t: Date.now() })); else localStorage.removeItem(PO_KEY); } catch (e) {}
    clearTimeout(poSave.t);
    poSave.t = setTimeout(function () {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { 'PO Number': v } }) }).catch(function () {});
    }, 500);
  }
  function poListen(e) {
    var t = e.target;
    if (t && (t.name === 'projectname' || t.id === 'po_number')) poSave(t.value);
  }
  document.addEventListener('input', poListen, true);
  document.addEventListener('change', poListen, true);
  function poFromPage() {
    /* framed: carried in the address from the first page */
    if (/\/pages\/customise/.test(location.pathname)) {
      var m = location.search.match(/[?&]projectname=([^&]*)/);
      if (m) { var v = decodeURIComponent(m[1].replace(/\+/g, ' ')); if (v.trim()) poSave(v); }
    }
    /* panels: the Vue store, in case the field was filled without typing (autofill) */
    var s = panelsStore();
    if (s && s.projectName && String(s.projectName).trim() !== poLast) poSave(s.projectName);
    /* basket: fill the box if it is empty */
    var box = document.getElementById('po_number');
    if (box && !box.value && !box.dataset.rog) { box.dataset.rog = '1'; var saved = poGet(); if (saved) { box.value = saved; poSave(saved); } }
  }

  /* 6. Signed-in customers: fill in name, company, phone and email on the
        first page of both calculators (only empty boxes, only once each). */
  var FILL = { fullname: 'name', name: 'name', companyname: 'company', phone: 'phone', email: 'email' };
  function prefillDetails() {
    var me = A.me;
    if (!me || A.isStaff || !onCalculator()) return;
    var forms = document.querySelectorAll('#form-BespokeMirrors-YourDetails, .your--details');
    forms.forEach(function (f) {
      Object.keys(FILL).forEach(function (n) {
        var i = f.querySelector('input[name="' + n + '"]'), v = me[FILL[n]];
        if (!i || !v || i.value || i.dataset.rogFilled) return;
        i.dataset.rogFilled = '1';
        Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(i, v);
        i.dispatchEvent(new Event('input', { bubbles: true }));
        i.dispatchEvent(new Event('change', { bubbles: true }));
        i.classList.add('rog-filled');
      });
    });
  }

  /* 7. Calculator intro wording – the same on both calculators.
        Replaces the old "For a trade price, please login…" paragraph. */
  var CONTACT = 'call us on <a href="tel:03455488586">0345 548 8586</a> or email <a href="mailto:info@rougholdglass.co.uk">info@rougholdglass.co.uk</a>';
  function tidyTradeText() {
    if (!onCalculator()) return;
    document.querySelectorAll('.framebox p').forEach(function (p) {
      if (p.dataset.rogTidy || !/for a trade price/i.test(p.textContent)) return;
      p.dataset.rogTidy = '1';
      p.innerHTML = A.loggedIn
        ? 'Questions? ' + CONTACT.charAt(0).toUpperCase() + CONTACT.slice(1) + '.'
        : 'No trade account yet? <a href="/pages/trade-account">Apply for a trade account</a>. ' +
          'Otherwise, carry on for a retail price. We’ll email you a copy of your estimate too. Questions? Call us on <a href="tel:03455488586">0345 548 8586</a>.';
    });
  }

  /* 8. Panels calculator items: rewrite the basket lines in the office / Capsule layout
        (FINISH, GLASS, EDGES ... ANTICIPATED LEAD TIME). Runs once per item, right after
        it is added and whenever the basket is loaded. Prices are not touched. */
  var LEAD_STD = '4-5 weeks for production & delivery', LEAD_FIT = '6-8 weeks for survey, production & installation';
  function capsuleProps(p) {
    var finish = String(p['Glass Finish'] || '').replace(/\s*Finish\s*$/i, '').trim();
    var f = finish.toLowerCase();
    var base = /fluted/.test(f) ? 'Fluted' : /on bronze/.test(f) ? 'Bronze Tinted' : /on grey/.test(f) ? 'Grey Tinted' : 'Clear';
    var tough = /tough/i.test(p['Glass Type'] || '');
    var glass = (p['Glass Thickness'] || '6mm') + ' ' + (tough ? base + ' Toughened' : (base === 'Clear' ? 'Plain' : base) + ' Float');
    var e = String(p['Edge Finish'] || 'None');
    var edges = /polish/i.test(e) ? 'PAR (Polished All Round)' : e.replace(/Bevelled/i, 'Bevel');
    var sizes = [], template = false, shaped = false;
    Object.keys(p).filter(function (k) { return /^Shape \d+$/.test(k); }).sort(function (a, b) { return parseInt(a.slice(6), 10) - parseInt(b.slice(6), 10); }).forEach(function (k) {
      var v = String(p[k]), m = v.match(/(\d+(?:\.\d+)?)mm x (\d+(?:\.\d+)?)mm \/ Qty (\d+)/);
      if (!m) { sizes.push(v); return; }
      var note = /out of square|straight line/i.test(v) ? ' (out of square)' : /circ/i.test(v) ? ' (circular)' : '';
      if (note) shaped = true;
      if (/template provided/i.test(v)) { template = true; note += ' (template)'; }
      sizes.push(m[3] + ' @ ' + m[1] + ' x ' + m[2] + 'mm' + note);
    });
    var d = String(p['Drawing'] || ''), walls = (d.match(/For (\d+) Wall/i) || [])[1] || '1';
    var wallTxt = walls + (walls === '1' ? ' wall' : ' walls');
    var x = String(p['Extras'] || '');
    var fit = /install/i.test(x);
    var drawing = fit ? null
      : template ? 'Template to be provided by you'
      : /dxf/i.test(d) ? 'DXF drawing to be provided by you (' + wallTxt + ')'
      : /sketch/i.test(d) ? 'Sketch to be provided by you (' + wallTxt + ')'
      : 'Not required';
    var out = {
      'FINISH': finish,
      'GLASS': glass,
      'EDGES': edges,
      'CUTOUTS/HOLES': p['Cutouts And Holes'] || 'None'
    };
    /* With survey & installation we measure on site and draw it up ourselves */
    if (fit) out['DRAWING REQUIRED FOR PRODUCTION'] = 'Yes – a DXF will be created by us after the survey';
    else if (!p._noDrawingInfo || template) out['DRAWING'] = drawing;
    Object.assign(out, {
      'DECORATIVE STUDS': p['Decorative Studs'] || 'None',
      'SIZES (W x H)': sizes.join(', '),
      'FOIL BACKING': '✓ Included',
      /* Installation always includes the adhesive */
      'ADHESIVE REQUESTED': fit ? '✓ Included with installation' : (/adhesive/i.test(x) ? '✓ Yes' : '✗ No')
    });
    if (/grout/i.test(x)) out['GROUT REQUESTED'] = '✓ Yes';
    if (fit) out['SURVEY & INSTALLATION'] = '✓ Included';
    out['ANTICIPATED LEAD TIME'] = fit ? LEAD_FIT : LEAD_STD;
    if (p._hashId) out._hashId = p._hashId;
    out._rog = '1';
    return out;
  }
  var fmtBusy = false, fmtChanged = false;
  function rogFormatCart() {
    if (fmtBusy) return; fmtBusy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var line = -1, item = null;
      (c.items || []).some(function (it, i) {
        var pr = it.properties || {};
        if (pr['Glass Finish'] != null && !pr._rog) { line = i + 1; item = it; return true; }
        return false;
      });
      if (!item) {
        fmtBusy = false;
        if (fmtChanged && /^\/cart\/?$/.test(location.pathname)) { fmtChanged = false; location.reload(); }
        return;
      }
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: item.quantity, properties: capsuleProps(item.properties) }) })
        .then(function (r) { if (!r.ok) throw new Error('change'); fmtChanged = true; fmtBusy = false; rogFormatCart(); });
    }).catch(function () { fmtBusy = false; });
  }
  if (window.fetch && !window.fetch.rogWrapped) {
    var origFetch = window.fetch;
    window.fetch = function (u, opts) {
      var url = '';
      try { url = String(u && u.url ? u.url : u); } catch (e) {}
      /* Calculator "Add to cart": reword the item before it goes into the basket */
      if (url.indexOf('/cart/add') > -1 && opts && typeof opts.body === 'string') {
        try {
          var b = JSON.parse(opts.body), items = b.items || [b], changed = false;
          items.forEach(function (it) {
            if (it && it.properties && it.properties['Glass Finish'] != null && !it.properties._rog) { it.properties = capsuleProps(it.properties); changed = true; }
          });
          if (changed) { opts = Object.assign({}, opts, { body: JSON.stringify(b) }); arguments[1] = opts; }
        } catch (e) {}
      }
      var pr = origFetch.apply(this, arguments);
      /* Safety net: anything that still arrives in the old wording is fixed straight after */
      /* Staff mode only takes over adds made on the calculators; samples and shop products go into the staff basket as normal (12 Oct 2026). */
      if (url.indexOf('/cart/add') > -1) pr.then(function (res) {
        setTimeout(rogFormatCart, 60);
        if (A.isStaff && onCalculator() && res && res.clone) res.clone().json().then(function (j) { staffDone(j && j.items ? j.items[0] : j); }).catch(function () {});
      });
      return pr;
    };
    window.fetch.rogWrapped = true;
  }

  /* 9. Show the same layout on the calculator's summary step and on the
        bespoke product's own page (the text there comes from Inspira). */
  function escHtml(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function specHtml(props) {
    return Object.keys(props).filter(function (k) { return k.charAt(0) !== '_'; }).map(function (k) {
      return '<p class="attr"><span>' + escHtml(k) + ':</span> ' + escHtml(props[k]) + '</p>';
    }).join('');
  }
  function summarySpec() {
    var s = panelsStore();
    var box = document.querySelector('.tiles-customiser .step--container.summary .right-grid > .step-font');
    if (!s || !box || !s.summaryLines) return;
    var sl = s.summaryLines, p = {};
    (sl.shape || []).forEach(function (v, i) { p['Shape ' + (i + 1)] = v; });
    if (s.drawing && s.drawing.hasDrawings && sl.drawing) p['Drawing'] = sl.drawing;
    p['Glass Finish'] = sl.glassFinish; p['Glass Thickness'] = sl.glassThickness; p['Glass Type'] = sl.glassType;
    p['Cutouts And Holes'] = sl.cutoutsAndHoles; p['Decorative Studs'] = sl.decorativeStuds;
    p['Edge Finish'] = sl.edgeFinish; p['Extras'] = sl.extras;
    var html = '<h3>Your specification</h3><hr>' + specHtml(capsuleProps(p));
    var mine = box.parentNode.querySelector('.rog-spec');
    if (!mine) { mine = el('div', 'step-font rog-spec'); box.parentNode.insertBefore(mine, box.nextSibling); }
    box.style.display = 'none';
    if (mine.dataset.html !== html) { mine.innerHTML = html; mine.dataset.html = html; }
  }
  function productSpec() {
    if (!/^\/products\//.test(location.pathname) || document.querySelector('.rog-spec')) return;
    var attrs = document.querySelectorAll('p.attr');
    if (!attrs.length) return;
    var p = { _noDrawingInfo: true }, cut = [], seen = false;
    attrs.forEach(function (a) {
      var sp = a.querySelector('span'); if (!sp) return;
      var label = sp.textContent.replace(/:\s*$/, '').trim();
      var parts = a.innerHTML.replace(sp.outerHTML, '').split(/<br\s*\/?>/i).map(function (x) { var d = document.createElement('div'); d.innerHTML = x; return d.textContent.trim(); }).filter(Boolean);
      var val = parts.join(', ');
      if (/panel shape/i.test(label)) { parts.forEach(function (x, i) { p['Shape ' + (i + 1)] = x.replace(/^\d+\.\s*/, ''); }); seen = true; }
      else if (/^cutouts$|^holes$/i.test(label)) { if (val && !/^none$/i.test(val)) cut.push(val); }
      else if (/glass finish/i.test(label)) p['Glass Finish'] = val;
      else if (/thickness/i.test(label)) p['Glass Thickness'] = val;
      else if (/glass type/i.test(label)) p['Glass Type'] = val;
      else if (/studs/i.test(label)) p['Decorative Studs'] = val;
      else if (/edge/i.test(label)) p['Edge Finish'] = val;
      else if (/extras/i.test(label)) p['Extras'] = val;
    });
    if (!seen || p['Glass Finish'] == null) return;
    p['Cutouts And Holes'] = cut.length ? cut.join(', ') : 'None';
    var first = attrs[0], wrap = el('div', 'rog-spec');
    wrap.innerHTML = specHtml(capsuleProps(p));
    first.parentNode.insertBefore(wrap, first);
    attrs.forEach(function (a) { a.style.display = 'none'; });
  }

  /* 10. Arriving from a sample page (?finish=Vintage): preselect that finish in
         whichever calculator they open. Remembered for the visit so it survives
         the framed calculator's first page. */
  var FIN_KEY = 'rogFinish';
  try {
    var fm = location.search.match(/[?&]finish=([^&]*)/);
    if (fm) sessionStorage.setItem(FIN_KEY, decodeURIComponent(fm[1].replace(/\+/g, ' ')));
  } catch (e) {}
  function normFin(t) {
    return String(t || '').toLowerCase().replace(/\s+finish\s*$/, '').replace(/\s+(tinted\s+)?glass\b/g, '').replace(/\s+/g, ' ').trim();
  }
  function preselectFinish() {
    if (!onCalculator()) return;
    var want; try { want = sessionStorage.getItem(FIN_KEY); } catch (e) {}
    if (!want) return;
    var els = document.querySelectorAll('#mirror-finish .frame-element, .tiles-customiser .glass--finish .frame-element');
    if (!els.length) return;
    var w = normFin(want), cands = [w, w + ' on clear'];
    try { sessionStorage.removeItem(FIN_KEY); } catch (e) {}
    for (var i = 0; i < els.length; i++) {
      var t = els[i].querySelector('.title');
      if (t && cands.indexOf(normFin(t.textContent)) > -1) { (els[i].querySelector('.image') || els[i]).click(); return; }
    }
  }

  /* 11. Staff mode (customer accounts tagged "Staff"): price a job for a customer on
         either calculator, then send it to them as a Shopify draft order. */
  var ADMIN_DRAFTS_URL = 'https://admin.shopify.com/store/rough-old-glass/draft_orders?query=';
  function custHtml() {
    var c = custGet(), rows = ['Name', 'Company', 'Email', 'Phone', 'PO / project'].filter(function (k) { return c[k]; });
    if (!rows.length) return '';
    return '<div class="rog-cust"><b>Customer details entered</b>' + rows.map(function (k) {
      return '<div><span>' + k + ':</span> ' + escHtml(c[k]) + ' <button type="button" class="rog-quiet rog-mini" data-copy="' + escHtml(c[k]) + '">Copy</button></div>';
    }).join('') + '</div>';
  }
  function staffRef(productId) { var s = String(productId || ''); return s ? 'RG-' + s.slice(-6) : ''; }
  var staffCss = [
    '.rog-staff-bar{display:flex;flex-wrap:wrap;align-items:center;gap:8px 14px;margin:14px 0;padding:12px 14px;border-radius:6px;background:#1f2a2b;color:#fff;font-size:15px;line-height:1.4;text-align:left}',
    '.rog-staff-bar strong{letter-spacing:.04em;text-transform:uppercase;font-size:13px}',
    '.rog-staff-bar .rog-seg{display:inline-flex;border:1px solid rgba(255,255,255,.5);border-radius:20px;overflow:hidden}',
    '.rog-staff-bar .rog-seg button{border:0;background:transparent;color:#fff;padding:6px 14px;font:inherit;font-size:14px;cursor:pointer}',
    '.rog-staff-bar .rog-seg button[aria-pressed="true"]{background:#fff;color:#1f2a2b;font-weight:700}',
    '.rog-staff-bar small{opacity:.8;font-size:13px}',
    '.rog-staff-done{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);z-index:10000;width:min(520px,calc(100vw - 32px));max-height:calc(100vh - 32px);overflow:auto;background:#fff;color:#1f2a2b;border-radius:10px;box-shadow:0 20px 60px rgba(0,0,0,.35);padding:20px;text-align:left;font-size:15px;line-height:1.5}',
    '.rog-staff-done h3{margin:0 0 6px;font-size:19px}',
    '.rog-staff-done .rog-ref{display:flex;align-items:center;gap:10px;margin:12px 0;padding:10px 12px;background:#f3f4f2;border-radius:8px;font-size:20px;font-weight:700;letter-spacing:.04em}',
    '.rog-staff-done ol{margin:10px 0 14px;padding-left:20px}',
    '.rog-staff-done .rog-actions{display:flex;flex-wrap:wrap;gap:8px}',
    '.rog-staff-done a.rog-go,.rog-staff-done button{display:inline-block;padding:9px 16px;border-radius:20px;border:1px solid #1f2a2b;background:#1f2a2b;color:#fff !important;text-decoration:none !important;font:inherit;font-weight:700;cursor:pointer}',
    '.rog-staff-done button.rog-quiet{background:transparent;color:#1f2a2b !important}',
    '.rog-staff-shade{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9999}',
    '.rog-staff-done .rog-cust{margin:4px 0 10px;padding:10px 12px;border:1px solid #e3e5e2;border-radius:8px;font-size:14px}',
    '.rog-staff-done .rog-cust div{display:flex;flex-wrap:wrap;align-items:center;gap:6px;margin-top:4px}',
    '.rog-staff-done .rog-cust span{color:#646b6f;min-width:90px}',
    '.rog-staff-done button.rog-mini{padding:2px 10px;font-size:12px;font-weight:600}'
  ].join('');

  function staffBar() {
    if (!A.isStaff || !onCalculator() || document.querySelector('.rog-staff-bar')) return;
    if (!document.getElementById('rog-staff-css')) { var sst = el('style'); sst.id = 'rog-staff-css'; sst.textContent = staffCss; document.head.appendChild(sst); }
    var anchor = document.querySelector('.frames-bespoke .framebox h1') || document.querySelector('.your--details h1, .your--details h2') ||
                 document.querySelector('.tiles-customiser .right-column') || document.querySelector('.frames-bespoke');
    if (!anchor) return;
    var bar = el('div', 'rog-staff-bar');
    var panels = /bespoke-tiles/.test(location.pathname);
    bar.innerHTML = '<strong>Staff mode</strong><span>Pricing a job for a customer.</span>' +
      (panels ? '<span class="rog-seg" role="group" aria-label="Price as"><button type="button" data-p="retail">Retail</button><button type="button" data-p="trade">Trade</button></span>'
              : '<small>Framed mirrors are priced at retail.</small>');
    if (anchor.classList && (anchor.classList.contains('right-column') || anchor.classList.contains('frames-bespoke'))) anchor.insertBefore(bar, anchor.firstChild);
    else anchor.parentNode.insertBefore(bar, anchor.nextSibling);
    bar.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[data-p]'); if (!b) return;
      setStaffPricing(b.getAttribute('data-p'));
    });
    syncStaffBar();
  }
  function setStaffPricing(mode) {
    var w = document.querySelector('.customiser--wrapper'), vm = w && w.__vue__ && w.__vue__.$root;
    if (!vm || !vm.$store) return;
    vm.$store.state.isTradeCustomer = mode === 'trade' ? 'true' : 'false';
    if (window.config && window.config.yourDetails) window.config.yourDetails.isTrade = mode === 'trade' ? 'true' : 'false';
    try { vm.$store.dispatch('calculate'); vm.$store.dispatch('generateSummaryLines'); } catch (e) {}
    syncStaffBar();
  }
  function syncStaffBar() {
    var s = panelsStore(), bar = document.querySelector('.rog-staff-bar'); if (!s || !bar) return;
    var trade = String(s.isTradeCustomer) === 'true';
    bar.querySelectorAll('button[data-p]').forEach(function (b) { b.setAttribute('aria-pressed', String((b.getAttribute('data-p') === 'trade') === trade)); });
  }

  /* The add-to-cart reply is not always Shopify's own (prices in pounds, not pence),
     so read the line back from the basket before showing it. */
  var CUST_KEY = 'rogStaffCust', CUST_FIELDS = { fullname: 'Name', name: 'Name', companyname: 'Company', email: 'Email', phone: 'Phone', projectname: 'PO / project' };
  function custGet() { try { return JSON.parse(sessionStorage.getItem(CUST_KEY) || '{}'); } catch (e) { return {}; } }
  function custListen(e) {
    var t = e.target; if (!A.isStaff || !t || !CUST_FIELDS[t.name]) return;
    var c = custGet(); c[CUST_FIELDS[t.name]] = String(t.value || '').trim();
    try { sessionStorage.setItem(CUST_KEY, JSON.stringify(c)); } catch (er) {}
  }
  document.addEventListener('input', custListen, true);
  document.addEventListener('change', custListen, true);

  function staffDone(item) {
    if (!A.isStaff || !item || !item.product_id || staffSeen[item.product_id]) return;
    staffSeen[item.product_id] = 1;
    var fallback = { product_id: item.product_id, product_title: item.product_title || item.title, noPrice: true };
    var look = function (tries) {
      (origFetch || fetch)('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var line = null;
        (c.items || []).forEach(function (it) { if (String(it.product_id) === String(item.product_id)) line = it; });
        if (line) staffShow(line); else if (tries > 0) setTimeout(function () { look(tries - 1); }, 1000); else staffShow(fallback);
      }).catch(function () { staffShow(fallback); });
    };
    setTimeout(function () { look(4); }, 600);
  }
  var staffSeen = {};
  function staffShow(item) {
    var old = document.querySelector('.rog-staff-done'); if (old) old.remove();
    var shade = document.querySelector('.rog-staff-shade'); if (shade) shade.remove();
    var ref = staffRef(item.product_id);
    shade = el('div', 'rog-staff-shade');
    var box = el('div', 'rog-staff-done'); box.setAttribute('role', 'dialog'); box.setAttribute('aria-label', 'Product created');
    box.innerHTML = '<h3>Product created for the draft order</h3>' +
      '<div>' + escHtml(item.product_title || item.title || '') + (item.noPrice ? '' : ' · ' + money((item.final_line_price || item.line_price || 0) / 100) + ' inc VAT') + '</div>' +
      '<div class="rog-ref"><span>' + ref + '</span><button type="button" class="rog-quiet" data-copy="' + ref + '">Copy</button></div>' +
      custHtml() +
      '<ol><li>Open the draft order. Shopify Flow has already made it, with the full specification and price.</li>' +
      '<li>Choose the customer (search by their email). An existing customer brings their tags and trade terms with them.</li>' +
      '<li>Add the PO if they have one, then <b>Send invoice</b>.</li></ol>' +
      '<div class="rog-actions"><a class="rog-go" href="' + ADMIN_DRAFTS_URL + encodeURIComponent(ref) + '" target="_blank" rel="noopener">Open draft order</a>' +
      '<button type="button" class="rog-quiet" data-close>Price another job</button></div>' +
      '<p style="margin:12px 0 0;font-size:13px;color:#646b6f">It has been taken out of your own basket. If the draft order is not listed yet, give it a minute and refresh.</p>';
    document.body.appendChild(shade); document.body.appendChild(box);
    try { sessionStorage.removeItem(CUST_KEY); } catch (e) {}   /* next job starts clean */
    box.querySelectorAll('[data-copy]').forEach(function (b) {
      b.onclick = function () {
        try { navigator.clipboard.writeText(b.getAttribute('data-copy')).then(function () { b.textContent = 'Copied'; }); } catch (e) {}
      };
    });
    var close = function () { box.remove(); shade.remove(); };
    box.querySelector('[data-close]').onclick = close; shade.onclick = close;
    /* keep the staff basket empty */
    if (item.key) (origFetch || fetch)('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 }) }).catch(function () {});
  }

  function tick() {
    fixLoginLinks();
    poFromPage();
    prefillDetails();
    tidyTradeText();
    calculatorPrompt();
    try { summarySpec(); productSpec(); preselectFinish(); staffBar(); syncStaffBar(); } catch (e) {}
    if ((A.isTrade || A.isStaff) && onCalculator()) { panelsMargin(); framedMargin(); }
  }

  function start() {
    headerButton();
    rogFormatCart();
    tick();
    var pending = false;
    try {
      new MutationObserver(function () {
        if (pending) return; pending = true;
        setTimeout(function () { pending = false; tick(); }, 250);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
